import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import { PALETTE, FONT_SIZES } from '~/assets/styles/base';
import { IndividualUserCategory, UserCategory } from '~/common/constants';

const Wrapper = styled.div`
  border-top: 1px solid ${PALETTE.border.frame};
`;

const Content = styled(Typography)`
  font-size: ${FONT_SIZES.bodyDefault};
  margin: 4px 0 10px 10px;
`;
const Title = styled(Typography)`
  font-size: ${FONT_SIZES.title3};
  margin: 20px 0 0 10px;
`;

const IdTitle = styled(Typography)`
  font-size: ${FONT_SIZES.title3};
  margin: 24px 0 0 10px;
`;

type Props = {
  user: {
    id: number;
    name?: string;
    category: UserCategory;
    individualCategory: IndividualUserCategory;
    companyName?: string;
    departmentName?: string;
    email?: string;
    password?: string;
    phone?: string;
    zip?: string;
    pref?: string;
    address?: string;
  };
};

const UserInfoArea: React.FC<Props> = ({ user }): JSX.Element => {
  const { t } = useTranslation();

  return (
    <>
      <IdTitle data-testid="uiParts-UserInfoArea-userIdTitle">{t('appCommon.userId')}</IdTitle>
      <Content data-testid="uiParts-UserInfoArea-userIdData">{user.id}</Content>
      <Wrapper>
        <Title data-testid="uiParts-UserInfoArea-userNameTitle">{t('registration.name')}</Title>
        <Content data-testid="uiParts-UserInfoArea-userNameData">{user.name}</Content>
      </Wrapper>
      <Wrapper>
        <Title data-testid="uiParts-UserInfoArea-userCategoryTitle">
          {t('registration.category')}
        </Title>
        <Content data-testid="uiParts-UserInfoArea-userCategoryData">
          {t(`registration.user.individualCategory.${user.individualCategory}`)}
        </Content>
      </Wrapper>
      {user.category === 2 && (
        <>
          <Wrapper>
            <Title data-testid="uiParts-UserInfoArea-userCompanyTitle">
              {t('registration.company')}
            </Title>
            <Content data-testid="uiParts-UserInfoArea-userCompanyData">{user.companyName}</Content>
          </Wrapper>
          <Wrapper>
            <Title data-testid="uiParts-UserInfoArea-userDepartmentTitle">
              {t('registration.departmentName')}
            </Title>
            <Content data-testid="uiParts-UserInfoArea-userDepartmentData">
              {user.departmentName}
            </Content>
          </Wrapper>
        </>
      )}
    </>
  );
};

export default UserInfoArea;
